export const ASSISTANCE_EMAIL_ADDRESS = "api@va.gov";

export const UPDATE_APPLICATION_EMAIL = 'UPDATE_APPLICATION_EMAIL';
export type UPDATE_APPLICATION_EMAIL = typeof UPDATE_APPLICATION_EMAIL;

export const UPDATE_APPLICATION_FIRST_NAME = 'UPDATE_APPLICATION_FIRST_NAME';
export type UPDATE_APPLICATION_FIRST_NAME = typeof UPDATE_APPLICATION_FIRST_NAME;

export const UPDATE_APPLICATION_LAST_NAME = 'UPDATE_APPLICATION_LAST_NAME';
export type UPDATE_APPLICATION_LAST_NAME = typeof UPDATE_APPLICATION_LAST_NAME;

export const UPDATE_APPLICATION_ORGANIZATION = 'UPDATE_APPLICATION_ORGANIZATION';
export type UPDATE_APPLICATION_ORGANIZATION = typeof UPDATE_APPLICATION_ORGANIZATION;

export const UPDATE_APPLICATION_DESCRIPTION = 'UPDATE_APPLICATION_DESCRIPTION';
export type UPDATE_APPLICATION_DESCRIPTION = typeof UPDATE_APPLICATION_DESCRIPTION;

export const UPDATE_APPLICATION_OAUTH_REDIRECT_URL = 'UPDATE_APPLICATION_OAUTH_REDIRECT_URL';
export type UPDATE_APPLICATION_OAUTH_REDIRECT_URL = typeof UPDATE_APPLICATION_OAUTH_REDIRECT_URL;

export const TOGGLE_BENEFITS_CHECKED = 'TOGGLE_BENEFITS_CHECKED';
export type TOGGLE_BENEFITS_CHECKED = typeof TOGGLE_BENEFITS_CHECKED;

export const TOGGLE_APPEALS_CHECKED = 'TOGGLE_APPEALS_CHECKED';
export type TOGGLE_APPEALS_CHECKED = typeof TOGGLE_APPEALS_CHECKED;

export const TOGGLE_HEALTH_CHECKED = 'TOGGLE_HEALTH_CHECKED';
export type TOGGLE_HEALTH_CHECKED = typeof TOGGLE_HEALTH_CHECKED;

export const TOGGLE_VERIFICATION_CHECKED = 'TOGGLE_VERIFICATION_CHECKED';
export type TOGGLE_VERIFICATION_CHECKED = typeof TOGGLE_VERIFICATION_CHECKED;

export const TOGGLE_FACILITIES_CHECKED = 'TOGGLE_FACILITIES_CHECKED';
export type TOGGLE_FACILITIES_CHECKED = typeof TOGGLE_FACILITIES_CHECKED;

export const SUBMIT_APPLICATION_BEGIN = 'SUBMIT_APPLICATION_BEGIN';
export type SUBMIT_APPLICATION_BEGIN = typeof SUBMIT_APPLICATION_BEGIN;

export const SUBMIT_APPLICATION_SUCCESS = 'SUBMIT_APPLICATION_SUCCESS';
export type SUBMIT_APPLICATION_SUCCESS = typeof SUBMIT_APPLICATION_SUCCESS;

export const SUBMIT_APPLICATION_ERROR = 'SUBMIT_APPLICATION_ERROR';
export type SUBMIT_APPLICATION_ERROR = typeof SUBMIT_APPLICATION_ERROR;

export const TOGGLE_ACCEPT_TOS = 'TOGGLE_ACCEPT_TOS';
export type TOGGLE_ACCEPT_TOS = typeof TOGGLE_ACCEPT_TOS;

// Media query values - see src/base.scss and node_modules/uswds/src/stylesheets/core/_variables.scss
export const MEDIUM_SCREEN = '640px';
export const OVER_MEDIUM_SCREEN_QUERY = 'screen and (min-width: 640px)';
export const UNDER_THAN_MEDIUM_SCREEN_QUERY = 'screen and (max-width: 639px)';

export const MEDIUM_LARGE_SCREEN = '768px';
export const OVER_MEDIUM_LARGE_SCREEN_QUERY = 'screen and (min-width: 768px)';
export const UNDER_MEDIUM_LARGE_SCREEN_QUERY = 'screen and (max-width: 767px)';

// Note: $large-screen is the same as $nav-width
export const LARGE_SCREEN = '951px';
export const OVER_LARGE_SCREEN_QUERY = 'screen and (min-width: 951px)';
export const UNDER_LARGE_SCREEN_QUERY = 'screen and (max-width: 950px)';
